import React from 'react'
import star_icon from '../../assets/images/icons/star-icon.png'
import DragAndDrop from '../dragAndDrop/file-upload.component'




const index = (props)=>{
    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <div className="dashboard-textfield-input" style={{flexDirection: 'column'}}>
                <DragAndDrop
                    accept=".jpg,.png,.jpeg,.pdf,.docx"
                    multiple
                    updateFilesCb={props.updateFilesCb}
                    hide={true}
                    dragText={true}
                    showFileModel={props.showFileModel}
                    handleRemoveItem={props.removeItem}
                    savedFile={props.savedFile}
                    downloadFile={props.downloadFile}
                    />
            </div>
        </div>

    )
}

export default index